'use es6';

import Log from 'forms-utils-lib/logger/Logger';
import { FormErrors, parseFormError } from 'FormsUI/api/Forms';
import { getPopupEditorRoute } from 'FormsUI/lib/RouteGenerators';
import { getUserEmail } from 'FormsUI/selectors/User';
import { getSelectedBusinessUnitId } from 'FormsUI/selectors/FormCreation';
import { getFormFieldLabel } from 'FormsUI/utils/FormFieldsUtils';
import PopupForm, { PopupFormKeys } from 'FormsUI/lib/PopupForm';
import { PopUpFormTypes } from 'FormsUI/constants/FormCreation';
import * as LeadFlowsApi from 'FormsUI/api/LeadFlows';
import { navigateTo } from 'FormsUI/utils/UrlUtils';
import { REQUEST_FORM_CREATION, SUCCEED_CREATING_FORM } from 'FormsUI/actions/formCreation/formCreationActions';
import { RETRY_MAX_ATTEMPTS, failCreatingForm } from '../FormCreation';
import { generateTimestampedName } from 'FormsUI/utils/FormCreationUtils';
import { getDefaultLegalConsentOption } from 'FormsUI/selectors/legalConsentOptions';
const createPopupForm = (attemptNumber = 1, options) => (dispatch, getState) => {
  const state = getState();
  const userEmail = getUserEmail(state);
  const defaultLegalConsentOptions = getDefaultLegalConsentOption(state);
  const businessUnitId = getSelectedBusinessUnitId(state);
  dispatch({
    type: REQUEST_FORM_CREATION
  });
  const defaultTriggers = {
    [PopupFormKeys.DISPLAY_ON_EXIT_INTENT]: !!options && options.type === PopUpFormTypes.POP_OVER,
    [PopupFormKeys.DISPLAY_ON_TIME_DELAY]: !!options && options.type !== PopUpFormTypes.POP_OVER ? 7000 : 0
  };
  const formToCreate = new PopupForm(Object.assign({
    [PopupFormKeys.NAME]: generateTimestampedName(attemptNumber),
    [PopupFormKeys.NOTIFICATION_EMAILS]: [userEmail],
    [PopupFormKeys.LEGAL_CONSENT_OPTIONS]: defaultLegalConsentOptions,
    [PopupFormKeys.IS_TYPE_EDITABLE]: false,
    [PopupFormKeys.BUSINESS_UNIT_ID]: businessUnitId
  }, defaultTriggers, options)).addFormField('email', getFormFieldLabel('Email'));
  return LeadFlowsApi.createForm(formToCreate).then(({
    formGuid
  }) => {
    dispatch({
      type: SUCCEED_CREATING_FORM
    });
    const popupEditorRoute = getPopupEditorRoute(formGuid);
    navigateTo(popupEditorRoute);
  }, ({
    xhr
  }) => {
    switch (xhr.status) {
      case 0:
        dispatch(failCreatingForm(FormErrors.NO_NETWORK));
        return;
      case 409:
        if (parseFormError(xhr) === FormErrors.DUPLICATE_NAME) {
          if (attemptNumber <= RETRY_MAX_ATTEMPTS) {
            Log.log(`Retrying to create a Popup form. Attempt ${attemptNumber} of ${RETRY_MAX_ATTEMPTS}.`);
            dispatch(createPopupForm(attemptNumber + 1, options));
            return;
          }
          Log.error(`Could not create form because of a name conflict after ${attemptNumber} attempts.`);
        }
      // If we didn't know how to handle this 409, let it fall-through
      // to the default error handling.
      // eslint-disable-next-line no-fallthrough
      default:
        dispatch(failCreatingForm(parseFormError(xhr)));
    }
  });
};
export default createPopupForm;